import { render } from "./BehfamLOGO.vue?vue&type=template&id=9040cffe&scoped=true"
import script from "./BehfamLOGO.vue?vue&type=script&lang=js"
export * from "./BehfamLOGO.vue?vue&type=script&lang=js"

import "./BehfamLOGO.vue?vue&type=style&index=0&id=9040cffe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9040cffe"]])

export default __exports__